import React from 'react';
import { ItemElement as Item } from './styles';

export const ItemElement = (props: any) => {
  return <Item {...props} />;
};
